<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
     :show="showDismissibleAlert" 
     dismissible 
     @dismissed="showDismissibleAlert = false"
     :variant="variant"
     >{{alertText }}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row class="justify-content-md-center">
        <b-col md="9" sm="12" class="mt-2">
          <p class="reg-heading-tab">Upload Group Related Documents</p>
          <p></p>
          <div class="reg-tab-container">
            <div class="row mb-2">
              <div class="col-md-12">
                <span 
                class="ln-eng"
                style="font-size: 0.875rem; color:red"
                v-if="currentLan == 'eng'">Upload Following
                  Documents For Existing Business.</span>
                <br />
                <span style="font-size: 0.875rem; color:red">Please note you can upload only jpg,png,pdf,gif extention
                  files.</span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <span
                 style="font-size: 0.875rem;"
                  class="ln-eng">Authorized Person Aadhaar Card(Front)</span>
              </div>
              <div class="col-md-4">
                <b-form-file
                 ref="fiAddharCard" 
                 @change="onFileChange2" 
                 v-if="form.UserLoanDocuments.AddharCardPath == ''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="addharcardpath" class="mt-3" plain></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.AddharCardPath != ''">
                <a :href="getImgUrl2(form.UserLoanDocuments.AddharCardPath)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.AddharCardPath)" alt="X" class="img-fluid" />
                </a>
                <b-button 
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('AddharCardPath', form.UserLoanDocuments.AddharCardPath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger" 
                  v-b-tooltip.hover title="Delete Document"
                  v-if="!getUser.LockProfile">
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br />
            <div class="row">
              <!-- <div class="col-md-4">
                <span style="font-size: 0.875rem;" class="ln-eng">Aadhaar Card(Back)</span>
              </div>
              <div class="col-md-4">
                <b-form-file
                  ref="fiAddharCardBack"
                  @change="onFileChange21"
                  v-if="form.UserLoanDocuments.AdharCardBackPath ==''"
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="AdharCardBackPath"
                  class="mt-3"
                  plain
                ></b-form-file>
              </div> -->
              <!-- <div class="col-md-4" v-if="form.UserLoanDocuments.AdharCardBackPath!=''">
                <a :href="getImgUrl2(form.UserLoanDocuments.AdharCardBackPath)" target="_blank">
                  <img
                    :src="getImgUrl(form.UserLoanDocuments.AdharCardBackPath)"
                    alt="X"
                    class="img-fluid"
                  />
                </a>
                <b-button
                  size="sm"
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('AdharCardBackPath', form.UserLoanDocuments.AdharCardBackPath)"
                  class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                  v-b-tooltip.hover
                  title="Delete Document"
                  v-if="!getUser.LockProfile"
                >
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div> -->
            </div>
            <br />
            <div class="row">
              <div class="col-md-4">
                <span style="font-size: 0.875rem;" class="ln-eng">Authorization Letter*</span>
              </div>
              <div class="col-md-4">
                <b-form-file 
                ref="fiPersonResolution" 
                @change="onFileChange1"
                v-if="form.UserLoanDocuments.PersonResolutionPath == ''" accept=".jpg, .png, .gif, .pdf"
                v-model="personresolutionpath" class="mt-3" plain></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.PersonResolutionPath != ''">
                <a :href="getImgUrl2(form.UserLoanDocuments.PersonResolutionPath)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.PersonResolutionPath)" alt="X" class="img-fluid" />
                </a>
                <b-button
                   size="sm" 
                   style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('PersonResolutionPath', form.UserLoanDocuments.PersonResolutionPath)"
                  class="mr-1 pt-0 pb-0" 
                  variant="outline-danger" 
                  v-b-tooltip.hover title="Delete Document"
                  v-if="!getUser.LockProfile">
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-4">
                <span style="font-size: 0.875rem;" class="ln-eng">Company Registration Copy</span>
              </div>
              <div class="col-md-4">
                <b-form-file
                 ref="fiRegCopy" 
                 @change="onFileChange3" 
                 v-if="form.UserLoanDocuments.RegCopy == ''"
                accept=".jpg, .png, .gif, .pdf" v-model="RegCopy" class="mt-3" plain></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.RegCopy != ''">
                <a :href="getImgUrl2(form.UserLoanDocuments.RegCopy)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.RegCopy)" alt="X" class="img-fluid" />
                </a>
                <b-button 
                  size="sm" 
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('RegCopy', form.UserLoanDocuments.RegCopy)" class="mr-1 pt-0 pb-0"
                  variant="outline-danger" 
                  v-b-tooltip.hover title="Delete Document" 
                  v-if="!getUser.LockProfile">
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-4">
                <span style="font-size: 0.875rem;" class="ln-eng">Bank Account Proof *</span>
                <p style="font-size: 0.75rem;color:#2284ab;">Bank Passbook or cancelled Cheque with Account Number and
                  IFSC.</p>
              </div>
              <div class="col-md-4">
                <b-form-file 
                  ref="fiBank" 
                  @change="onFileChange57" 
                  v-if="form.UserLoanDocuments.BankAccount == ''"
                  accept=".jpg, .png, .gif, .pdf" 
                  v-model="BankAccount" class="mt-3" plain required>
                </b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.BankAccount != ''">
                <a :href="getImgUrl2(form.UserLoanDocuments.BankAccount)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.BankAccount)" alt="X" class="img-fluid" />
                </a>
                <b-button 
                  size="sm" 
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('BankAccount', form.UserLoanDocuments.BankAccount)" class="mr-1 pt-0 pb-0"
                  variant="outline-danger" 
                  v-b-tooltip.hover title="Delete Document" 
                  v-if="!getUser.LockProfile">
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br />
            <!--Other Document-->
            <div class="row">
              <div class="col-md-4">
                <span class="ln-eng" style="font-size: 0.875rem;" 
                v-if="currentLan == 'eng'">Other Document</span>

                <b-form-input id="inpBranch" type="text" v-model="form.UserLoanDocuments.OtherName" size="sm"
                  placeholder="Other Documets"></b-form-input>
              </div>
              <div class="col-md-4">
                <b-form-file 
                  ref="fiODs" 
                  @change="onFileChange5" 
                  accept=".jpg, .png, .gif, .pdf" 
                  size="sm"
                  v-if="form.UserLoanDocuments.OtherDocument == ''" 
                  v-model="OtherDocument" class="mt-3"
                  plain></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.OtherDocument != ''">
                <a :href="getImgUrl2(form.UserLoanDocuments.OtherDocument)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.OtherDocument)" width="100px" class="img-fluid" />
                </a>
                <b-button 
                  size="sm" 
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('OtherDocument', form.UserLoanDocuments.OtherDocument)"
                  class="mr-1 pt-0 pb-0" 
                  variant="outline-danger" 
                  v-b-tooltip.hover title="Delete Document">
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br />
            <!--Other Document-->

            <!--Other Document2-->
            <div class="row">
              <div class="col-md-4">
                <span class="ln-eng" style="font-size: 0.875rem;" v-if="currentLan == 'eng'">Other Document 2</span>
                <b-form-input id="inpBranch" type="text" v-model="form.UserLoanDocuments.Other2Name" size="sm"
                  placeholder="Enter Document Name"></b-form-input>
              </div>
              <div class="col-md-4">
                <b-form-file 
                  ref="fiOD2" 
                  @change="onFileChange52" 
                  accept=".jpg, .png, .gif, .pdf" 
                  size="sm"
                  v-if="form.UserLoanDocuments.Other2 == ''" 
                  v-model="OtherDocument2" class="mt-3" plain></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.Other2 != ''">
                <a :href="getImgUrl2(form.UserLoanDocuments.Other2)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.Other2)" width="100px" class="img-fluid" />
                </a>
                <b-button 
                  size="sm" 
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('Other2', form.UserLoanDocuments.Other2)" class="mr-1 pt-0 pb-0"
                  variant="outline-danger"
                   v-b-tooltip.hover title="Delete Document">
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br />
            <!--Other Document2-->

            <!--Other Document3-->
            <div class="row">
              <div class="col-md-4">
                <span class="ln-eng" style="font-size: 0.875rem;" v-if="currentLan == 'eng'">Other Document 3</span>
                <b-form-input id="inpBranch" type="text" v-model="form.UserLoanDocuments.Other3Name" size="sm"
                  placeholder="Enter Document Name"></b-form-input>
              </div>
              <div class="col-md-4">
                <b-form-file 
                  ref="fiOD3" 
                  @change="onFileChange53" 
                  accept=".jpg, .png, .gif, .pdf" 
                  size="sm"
                  v-if="form.UserLoanDocuments.Other3 == ''" 
                  v-model="OtherDocument3" class="mt-3" plain></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.Other3 != ''">
                <a :href="getImgUrl2(form.UserLoanDocuments.Other3)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.Other3)" width="100px" class="img-fluid" />
                </a>
                <b-button 
                  size="sm" 
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('Other3', form.UserLoanDocuments.Other3)" class="mr-1 pt-0 pb-0"
                  variant="outline-danger" 
                  v-b-tooltip.hover title="Delete Document">
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br />
            <!--Other Document3-->

            <!--Other Document4-->
            <div class="row">
              <div class="col-md-4">
                <span class="ln-eng" style="font-size: 0.875rem;" v-if="currentLan == 'eng'">Other Document 4</span>
                <b-form-input id="inpBranch" type="text" v-model="form.UserLoanDocuments.Other4Name" size="sm"
                  placeholder="Enter Document Name"></b-form-input>
              </div>
              <div class="col-md-4">
                <b-form-file 
                  ref="fiOD4" 
                  @change="onFileChange54" 
                  accept=".jpg, .png, .gif, .pdf" 
                  size="sm"
                  v-if="form.UserLoanDocuments.Other4 == ''"
                  v-model="OtherDocument4" class="mt-3" plain></b-form-file>
              </div>
              <div class="col-md-4" v-if="form.UserLoanDocuments.Other4 != ''">
                <a :href="getImgUrl2(form.UserLoanDocuments.Other4)" target="_blank">
                  <img :src="getImgUrl(form.UserLoanDocuments.Other4)" width="100px" class="img-fluid" />
                </a>
                <b-button
                  size="sm" 
                  style="margin-left:0.5rem"
                  @click.stop="deleteDocument2('Other4', form.UserLoanDocuments.Other4)" class="mr-1 pt-0 pb-0"
                  variant="outline-danger" 
                  v-b-tooltip.hover title="Delete Document">
                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                </b-button>
              </div>
            </div>
            <br />
            <!--Other Document4-->
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2 justify-content-md-center" v-if="!getUser.LockProfile">
        <b-col md="5" sm="12" style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert :show="showDismissibleAlert" dismissible @dismissed="showDismissibleAlert = false"
            :variant="variant">{{ alertText }}</b-alert>
        </b-col>
        <b-col md="4" sm="12" style="text-align:right" class="button-wrap">
          <b-button @click="onSubmit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-modal id="modalConfirm" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { uploadPortalDocument } from "@/services/documentUpload";
import { protectedDocumentUrl } from "@/services/tenantDocuments";

import apis from "@/apis";
import * as _ from "lodash";
import axios from "axios";

import lambda from "@/apis/lambda";
import Spinner from "vue-simple-spinner";
import store from '../../store';
const _SheetJSFT = ["jpeg", "jpg", "png", "pdf"]
  .map(function (x) {
    return "." + x;
  })
  .join(",");
export default {
  components: { Spinner },
  data() {
    return {
      userId: "",
      imgPath: "",
      currentLan: "eng",
      show: true,
      Photo: null,
      PAN: null,
      Signature: null,
      addharcardpath: null,
      rationCard: null,
      dob: null,
      personresolutionpath: null,
      CastCertificate: null,
      RegCopy: null,
      Degree: null,
      Experience: null,
      RecoLetter: null,
      CourtOrder: null,
      DeceasedID: null,
      LegalHireNOC: null,
      FinalDuesLetter: null,
      BankAccount: null,
      OtherDocument: null,
      OtherDocument2: null,
      OtherDocument3: null,
      OtherDocument4: null,
      AdharCardBackPath: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved: false,
      docObj: {},
      docTbl: [],
      modalInfo: "",
      selecteObj: {
        Document: "",
        Path: ""
      },
      fields: [
        { key: "Document", label: "Document" },
        { key: "Path", label: "File" },
        { key: "action", label: "View" }
      ],
      form: {
        UserLoanDocuments: {
          PersonResolutionPath: "",
          AddharCardPath: "",
          RegCopy: "",
          CastCertificate: "",
          OtherDocument: "",
          PhotoPath: "",
          SignaturePath: "",
          AdharCardPath: "",
          AdharCardBackPath: "",
          PancardPath: "",
          RationCardPath: "",
          CasteCertificate: "",
          EduCertificate: "",
          ExServiceManProof: "",
          ExprienceCertificate: "",
          BirthCertificate: "",
          RecommendationLetter: "",
          CourtOrder: "",
          DeceasedID: "",
          LegalHireNOC: "",
          FinalDuesLetter: "",
          PoliceVerification: "",
          BankAccount: "",
          Other2: "",
          Other3: "",
          Other4: "",
          OtherName: "",
          Other2Name: "",
          Other3Name: "",
          Other4Name: ""
        },
        LoanApplication: [
          {
            LoanType: 2,
            UserID: "00000000-0000-0000-0000-000000000000"
          }
        ],
        LoginID: "00000000-0000-0000-0000-000000000000",
        maxFileSize: 1048576
      }
    };
  },
  computed: {
    getUserCat() {
      let x = this.$store.getters.getUserData;
      //console.log("X", x);
      if (x.UserReligionCaste) {
        if (
          x.UserReligionCaste.CategoryID ==
          "d25679fb-92ea-434d-a0f8-65b3290c7a8b"
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    getUser() {
      let x = this.$store.getters.getUserData;

      if (x) {
        return x;
      } else {
        return { LockProfile: false };
      }
    }
  },
  methods: {
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    deleteDocument2(document, path) {
      //console.log(item);
      this.selecteObj.Document = document;
      this.selecteObj.Path = path;

      let info = "You want to delete record for:" + "\n" + document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }

        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          protectedDocumentUrl("https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic)
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          protectedDocumentUrl("https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic)
        );
      }
    },
    showImages(item, index, target) {
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      let link =
        "https://aws.msobcfdc.in/S3BucketApril/" +
        userid +
        "/" +
        item.Path;
      // this.imgPath = link;
      // this.$refs.myModalRef.show()
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    constructFilePath(userid, prefix, extn) {
      return {
        _filepath: `${userid}!!~~!!${prefix}.${extn}`,
        filepath: `${prefix}.${extn}`
      };
    },

    validateFile(files, ref, maxSize = this.maxFileSize) {
      if (!files.length) return false;

      const strings = files[0].name.split(".");
      const extn = strings.length > 0 ? strings[strings.length - 1].toLowerCase() : null;

      if (!["jpeg", "png", "jpg", "pdf"].includes(extn)) {
        this.showDismissibleAlert = true;
        this.alertText = "Wrong File Input";
        this.variant = "warning";
        this.$refs[ref].reset();
        return false;
      }

      if (files[0].size > maxSize) {
        this.showDismissibleAlert = true;
        this.alertText = `Please upload a file less than ${maxSize / 1048576} MB`;
        this.variant = "warning";
        this.$refs[ref].reset();
        return false;
      }

      return extn;
    },

    uploadFile(e, ref, documentKey, prefix) {
      const files = e.target.files || e.dataTransfer.files;
      const extn = this.validateFile(files, ref);

      if (!extn) return;

      const userinfo = this.$store.getters.loggedUser;
      const userid = userinfo.UserId;
      const { _filepath, filepath } = this.constructFilePath(userid, prefix, extn);

      console.log("Constructed _filepath:", _filepath); // Debugging _filepath
      console.log("Constructed filepath:", filepath); // Debugging filepath

      const data = new FormData();
      data.append("file", files[0], _filepath);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${store.getters.authToken}`
        }
      };

      uploadPortalDocument("https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter", data, config)
        .then(response => {
          if (response.status === 200) {
            this.form.UserLoanDocuments[documentKey] = filepath;
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
            this.$refs[ref].reset();
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.$refs[ref].reset();
          this.isLoading = false;
        });
    },

    onFileChange1(e) {
      this.uploadFile(e, "fiPersonResolution", "PersonResolutionPath", "AuthorizationCopy");
    },

    onFileChange2(e) {
      this.uploadFile(e, "fiAddharCard", "AddharCardPath", "ResidentialProof");
    },

    onFileChange3(e) {
      this.uploadFile(e, "fiRegCopy", "RegCopy", "RegCopy");
    },

    onFileChange5(e) {
      this.uploadFile(e, "fiODs", "OtherDocument", "OtherDocument");
    },

    onFileChange52(e) {
      this.uploadFile(e, "fiOD2", "Other2", "OtherDocument2");
    },

    onFileChange53(e) {
      this.uploadFile(e, "fiOD3", "Other3", "OtherDocument3");
    },

    onFileChange54(e) {
      this.uploadFile(e, "fiOD4", "Other4", "OtherDocument4");
    },

    onFileChange57(e) {
      this.uploadFile(e, "fiBank", "BankAccount", "BankAccount");
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
      // this.form.LoanApplication[0].LoanType = this.$store.getters.getScheme.LoanType;
      // this.form.LoanApplication[0].UserID = userinfo.UserId;
      let promise = apis.saveLoanDocumentPath(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.loadLoanImageList();
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.$refs.fiPersonResolution.reset();
      this.$refs.fiAddharCard.reset();
      this.$refs.fiAddharCardBack.reset();
      this.$refs.fiRegCopy.reset();
      this.$refs.fiCCt.reset();
      this.$refs.fiODs.reset();
      this.$refs.fiPV.reset();
      this.$refs.fiReco.reset();
    },
    deleteDocument(item, index, button) {
      //console.log(item);
      this.selecteObj.Document = item.Document;
      this.selecteObj.Path = item.Path;

      let info = "You want to delete record for:" + "\n" + item.Document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },

    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
      let promise = apis.saveLoanDocumentPath(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            if (this.docTbl.length > 0) {
              this.loadLoanImageList();
            }

            switch (this.selecteObj.Document) {
              case "PersonResolutionPath":
                this.$refs.fiPersonResolution.reset();
                break;
              case "AddharCardPath":
                this.$refs.fiAddharCard.reset();
                break;
              case "AdharCardBackPath":
                this.$refs.fiAddharCardBack.reset();
                alert(this.selecteObj.Document);
                break;
              case "RegCopy":
                this.$refs.fiRegCopy.reset();
                break;
              case "CastCertificate":
                this.$refs.fiCCt.reset();
                break;
              case "OtherDocument":
                this.$refs.fiODs.reset();
                break;

              case "BankAccount":
                this.$refs.fiBank.reset();
                break;
            }
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },
    loadLoanImageList() {
      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;

      var userid = userinfo.UserId;
      //   var filename =   this.Photo.name;
      let promise = apis.readLoanDocumentPath(userid);
      this.docTbl = [];
      promise
        .then(response => {
          if (response.status == 200) {
            this.form.UserLoanDocuments = response.body;
            // console.log('Documents', response.body);
            this.docObj = response.body;
            for (var key in this.docObj) {
              if (this.docObj.hasOwnProperty(key)) {
                if (this.docObj[key]) {
                  if (this.docObj[key] != "" && this.docObj[key] != null) {
                    let link =
                      "https://aws.msobcfdc.in/S3BucketApril/" +
                      userid +
                      "/" +
                      this.docObj[key];

                    this.docTbl.push({
                      Document: key,
                      Path: this.docObj[key],
                      link: link
                    });
                  }
                }
                //console.log(key + " -> " + this.docObj[key]);
              }
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    }
  },
  mounted() {
    var userinfo = this.$store.getters.loggedUser;

    if (this.$store.getters.isLoggedIn) {
      this.loadLoanImageList();
    }
  }
};
</script>

<style scoped>
img {
  width: 50px;
  border-radius: 2px;
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.5);
  transition: width 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/FormUploadGpLoan.vue